import { Outlet } from "react-router-dom";
import KitchenHeader from "../components/kitchen/KitchenHeader";
import { KitchenProvider } from "../components/kitchen/KitchenContext";
import { useKitchenSocket } from "hooks/useKitchenSocket";
import { useKitchenManagementSocket } from "hooks/useKitchenManagementSocket";
import { useEffect, useState } from "react";
import { useSocketLogout } from "../hooks/useSocketLogout";
export default function KitchenLayout() {
  const { connect } = useKitchenSocket();
  const { connectManagement } = useKitchenManagementSocket();
  const [kitchenID, setKitchenID] = useState(null);
  const [kitchenUserEmail, setKitchenUserEmail] = useState(null);
  useSocketLogout();
  useEffect(() => {
    const id = localStorage.getItem("branchKitchenId");
    const email = localStorage.getItem("email");
    if (id) setKitchenID(id);
    if (email) setKitchenUserEmail(email);
  }, []);

  useEffect(() => {
    async function connectSocket() {
      if (kitchenID) {
        await connect(kitchenID);
        await connectManagement(kitchenID, kitchenUserEmail);
      }
    }
    connectSocket();
  }, [kitchenID, connect, connectManagement, kitchenUserEmail]);
  return (
    <KitchenProvider>
      <div className="bg-[#F5F5F5] min-w-full">
        <div className="">
          <KitchenHeader />
        </div>
        <div className="pt-[75px] w-full overflow-scroll KitchenScroll">
        <Outlet />
        </div>

        
      </div>
    </KitchenProvider>
  );
}
